import { CEDatafeedAttributesBase } from './ce-datafeed-attributes-base'


export class CEDatafeedAttributes extends CEDatafeedAttributesBase {

}